
import { Options, prop, Vue } from "vue-class-component";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import { display } from "html2canvas/dist/types/css/property-descriptors/display";

class Props {
  loading = prop<boolean>({
    default: false,
    type: Boolean
  });

  skeletonCount = prop<number>({
    default: 1,
    type: Number
  });

  title = prop<string>({
    default: '',
    type: String
  });

  totalString = prop<string>({
    default: '',
    type: String
  });

  subtotalString = prop<string>({
    default: '',
    type: String
  });

  data = prop<any>({
    default: [],
    type: Array
  });

  displayType = prop<string>({
    default: 'money',
    type: String
  });
}

@Options({
  components: {
    Accordion,
    AccordionTab,
  },
})

class SummaryCodCourier extends Vue.with(Props) {
}

export default SummaryCodCourier;
